<template>
    <div class="login-page">
      <div class="login-left">
        <div class="left-version" v-if="false">
          <span>{{ version }}</span>
        </div>
        <div class="Hblock">&nbsp;</div>
        <div tabindex="0">
          <div class="left-name">{{ $tran('Lenovo') }}</div>
          <div class="left-subName">{{ $tran('Display Fleet Manager') }}</div>
        </div>
      </div>
      <div class="login-block account-padding">
        <div class="login-account">
          <cus-input class="login-animation1" :placeholder="$tran('Enter your account ID')" v-model="ruleForm.username" @blur="validateAccount" password>
              <img slot="prefix" src="@/assets/login/password.png" alt="">
          </cus-input>
          <cus-input id="loginPassword" class="login-animation2" :type="passwordVisable ? 'password' : 'text'" :placeholder="$tran('Enter your password')" v-model="ruleForm.password" @keyup.enter.native="signIn" password>
            <img slot="prefix" src="@/assets/login/account.png" alt="">
            <i @click="passwordVisable = !passwordVisable" slot="suffix" :class="passwordVisable ? 'el-icon-lock' : 'el-icon-unlock'"></i>
          </cus-input>
        </div>
        <div role="button" tabindex="0" class="login-btn login-animation3" @click="signIn" @keypress.enter="signIn">
          <span>{{ $tran('Log In') }}</span>
        </div>
        <div class="login-desc login-animation4">
          <span role="button" tabindex="0" @click="resetPassword">{{ $tran('Reset Password?') }}</span>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import { postRequest, getRequest } from "@/api/api.js";
  import { wPlaceHolder } from '../../components/wPlaceHolder';
  export default {
    name: "LDFMLogin",
    data() {
      return {
        isShowPassword: false,
        ruleForm: {
          username: "",
          //password: "",
        },
        visible: false,
        passwordVisable: true,
        version: null
      };
    },
    computed: {
      // is userful reset password
      isDisableReset() {
        return (!this.ruleForm.username && this.ruleForm.username !== 0);
      }
    },
    methods: {
      validateAccount() {
        if(this.ruleForm.username && this.ruleForm.username === 'admin') {
          getRequest('/system/auth/auth').then(res => {
            if(res && res.code === 200 && res.data) {
              //this.$message.info(this.$tran('Please copy this password into the input box: ') + res.data, null, 10000);
              window.setCookie("pd",res.data);
              window.PasswordLongTip.show(this.$tran('Please copy this password into the input box: ') + res.data);
            };
          })
        }
      },
      async signIn() {
        if(!this.ruleForm.username && this.ruleForm.username !== 0) {
     
          this.$message.info('Enter your account ID');
          return;
        }
        if(!this.ruleForm.password && this.ruleForm.password !== 0) {
         
          this.$message.info('Enter your password');
          return;
        }

        this.$loading(true);
        if(window.backendCode == "401") // if server is starting then backend return 502
        {
          this.$loading(false);
          setTimeout(()=>{
            this.$loading(false);
          },6000);
          
        }
        // simulate token store browser cache
        try {
          const keyRequest = await getRequest('/system/auth/getPublicKey');
          if(!keyRequest || keyRequest.code !== 200) return;
          const response = await postRequest('/system/auth/login', {
            username: this.$passwordKey(this.ruleForm.username, keyRequest.data),
            password: this.$passwordKey(this.ruleForm.password, keyRequest.data)
          });
          
          if (response.code == 200) {
            //sessionStorage.setItem('token', response.data.accessToken);
            //sessionStorage.setItem('rToken', response.data.refreshToken);
            if(!window.isProduction())
            {
              window.setCookie('token', response.data.accessToken);
              window.setCookie('rToken', response.data.refreshToken);              
            }
            else
            {
              localStorage.setItem("isGetToken","true"); //backend set token success add by wuweiwei
            }
            
            await this.$store.dispatch('isHasLoginData', () => {
              if(window.isProduction())
              {
                localStorage.setItem("isGetToken","true"); //backend set token success add by wuweiwei
              }
              this.$message.success('Logged in successfully');
              this.$router.push(this.$store.state.menuArr[0].path);
            });
            
          }
        } catch (error) {
          //sessionStorage.setItem('token', '');
          window.removeCookie('token');
        } finally {
          this.$loading(false);
        }
      },
      resetPassword() {
        if(this.isDisableReset) {
          this.$message.info('Please Enter your x', 'account ID');
          return;
        }
        this.$message.info('Please contact the system administrator to reset your password');
      }
    },
    created() {
      this.version = window.version || 'v 1.0.1.1';
    },
    mounted() {
      if(process.env.NODE_ENV === 'development') {
        this.ruleForm = {
          username: "",
          //password: "",
        }
      }
      setTimeout( ()=>{
        try
        {
          document.querySelector(".login-animation2 input").setAttribute("title", this.$tran("Cannot exceed 20 characters"));
        }
        catch(e){}
        
      },1000);
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @for $i from 1 through 4 {
    .login-animation#{$i} {
      opacity: 0;
      animation-name: error-num;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
      animation-delay: calc($i/10) + s;
    }
  }
  
  .login-page {
    margin: 0 auto;
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    background: url('@/assets/login/loginBack.png') no-repeat;
    background-size: cover;
  
    .login-left {
      /*flex: 1;*/
      /*margin: calc( 286px / 1080px * 100vh ) 0 0 185px;*/
      margin: 0 auto;
      padding-left:2rem;
      padding-right: 2rem;
      /*transform: translate(0,100%);*/
      height: 305px;
      box-sizing: border-box;

      position: relative; /*add by wuweiwei */
      top: 50%; /*add by wuweiwei */
      margin-top: -15rem; /*add by wuweiwei */
      .Hblock{
        height: 70px;
      }
      .left-version {
        width: 147px;
        height: 69px;
        text-align: center;
        line-height: 69px;
        margin-bottom: 58px;
        border-radius: 40px;
        font-size: 28px;
        font-weight: 900;
        background: var(--base-loginBackground-color);
      }
      .left-name {
        font-size: 3.2rem;
        font-weight: 900;
        color: #101015;
        margin: 0 0 20px 0;
      }
      .left-subName {
        font-size: 3.2rem;
        color: #101015;
        font-weight: 900;
        overflow: hidden;
        white-space:nowrap;
      }
    }
  
    .login-block {
      width: 50%;
      box-sizing: border-box;
      height: 100%;
      /*padding: 0 202px 0 128px;*/
      padding: 0 50px 0 50px;
      background-color: rgba(255, 255, 255, 0.55);
      /*margin: auto;*/
      &.account-padding {
        padding-top: calc( 338px / 1080px * 100vh );
      }
      >div {
        /*width: 565px;*/
        width: 60%;
        margin: 0 auto;
      }

      .login-account {
        margin-bottom: 73px;
        >div:not(:last-of-type) {
          margin-bottom: 20px;
        }
        ::v-deep .base-input {
          input {
            background-color: #DEEAFC;
            padding: 10px 0 10px 73px;
            height: 60px;
          }
          .base-input-prefix {
            left: 20px;
            display: flex;
            align-items: center;
            position: absolute;
            &::after {
              content: "";
              width: 1px;
              height: 12px;
              background: #0F172A;
              position: absolute;
              left: 34px;
            }
            img {
              height: 16px;
            }
          }
          .base-input-suffix {
            right: 40px;
            display: flex;
            align-items: center;
            color: #0f172a;
            font-size: 18px;
            img {
              height: 16px;
            }
          }
          &::placeholder,
          &::-webkit-input-placeholder,
          /* 火狐 */
          &:-moz-placeholder,
          /*ie*/
          &:-ms-input-placeholder {
            color: #0F172A;
          }
        }
      }
  
      .login-btn {
        /*width: 100%;*/
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: var(--base-primary-color);
        border-radius: 10px;
        color: #ffffff;
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
      }
  
      .login-desc {
        display: flex;
        justify-content: space-between;
        padding: 0 5px;
        box-sizing: border-box;
        margin-top: 12px;
        font-size: 14px;
        color: var(--base-primary-color);
        cursor: pointer;
      }
    }
  }
  .login-animation1{
    font-size: 14px !important;
  }
  .login-animation2{
    font-size: 14px !important;
  }
  </style>
  